// extracted by mini-css-extract-plugin
module.exports = {"container":"e_vt","desc":"e_wt","val":"e_xt","icon":"e_yt"};